import { render, staticRenderFns } from "./NotificationsTaskTemplate.vue?vue&type=template&id=22d7f938&scoped=true&lang=pug"
import script from "./NotificationsTaskTemplate.vue?vue&type=script&lang=ts"
export * from "./NotificationsTaskTemplate.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsTaskTemplate.vue?vue&type=style&index=0&id=22d7f938&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7f938",
  null
  
)

export default component.exports